export default __webpack_public_path__ + "static/media/news-3.2e20a293.jpg";